import { DiagnosticJson } from "../echoflicks/journey/DiagnosticFields";
import type { MonitorRun, MonitorStage } from "./types";

function trustedLookup(
  stage: MonitorStage,
  environment: MonitorRun["environment"],
) {
  const lookup = stage.diagnostic_lookup;
  const eventId = stage.last_error?.sentry_event_id;
  if (
    !lookup ||
    lookup.state !== "lookup" ||
    !eventId ||
    !/^[a-f0-9]{32}$/.test(eventId)
  )
    return null;
  try {
    const url = new URL(lookup.url);
    if (
      url.origin !== "https://echoflicks.sentry.io" ||
      url.pathname !== "/organizations/echoflicks/issues/" ||
      url.username ||
      url.password ||
      url.hash ||
      url.searchParams.size !== 3 ||
      url.searchParams.get("query") !== eventId ||
      url.searchParams.get("environment") !== environment ||
      url.searchParams.get("project") !== "-1"
    )
      return null;
    return url.href;
  } catch {
    return null;
  }
}

export function DiagnosticEvidence({
  stage,
  environment,
  title = "Diagnostic",
}: {
  stage: MonitorStage;
  environment: MonitorRun["environment"];
  title?: string;
}) {
  if (!stage.last_error) return null;
  const href = trustedLookup(stage, environment);
  return (
    <section className="space-y-2">
      <DiagnosticJson title={title} value={stage.last_error} />
      {href ? (
        <>
          <a
            className="text-primary underline"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Sentry
          </a>
          <p className="text-xs text-muted-foreground">
            {stage.diagnostic_lookup?.project} · The event may be unavailable or
            expired.
          </p>
        </>
      ) : (
        <p className="text-xs text-muted-foreground">
          Sentry lookup unavailable.
        </p>
      )}
    </section>
  );
}
